<template>
  <div class="file-previewer">
    <div v-if="isDisplaying">
      <button class="btn btn-default" type="button" @click="isDisplaying = false">Hide content</button>
      <br /><br />

      <img v-if="images.find(extension => name.endsWith(extension))" :src="source" :alt="name">
      <video v-if="videos.find(extension => name.endsWith(extension))" controls controlsList="nodownload">
        <source :src="getStream()" type="video/mp4" />
      </video>

      <audio v-if="audios.find(extension => name.endsWith(extension))" controls controlsList="nodownload">
        <source :src="getStream()" type="audio/mpeg" />
      </audio>
    </div>
    
    <button class="btn btn-default" type="button" v-else @click="isDisplaying = true">Show content</button>
  </div>
</template>

<script>
import config from '../../config'
export default {
  name: 'FilePreviewer',
  props: {
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    source: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isDisplaying: false,
      images: ['.jpg', '.jpeg', '.png'],
      videos: ['.mp4'],
      audios: ['.mp3', '.wav']
    }
  },
  methods: {
    getStream () {
      return `${config.streamingURI}/${this.id}/${this.name}?token=${window.localStorage.getItem('token').substring(7)}`
    }
  }
}
</script>

<style scoped>
.file-previewer {
  margin: 1em;
}

.file-previewer img, .file-previewer video, .file-previewer audio {
  width: 100%;
} 
</style>



// WEBPACK FOOTER //
// FilePreviewer.vue?4cdde7e9